import { render, staticRenderFns } from "./roleNumber.vue?vue&type=template&id=1ccf31ce&scoped=true&"
import script from "./roleNumber.vue?vue&type=script&lang=js&"
export * from "./roleNumber.vue?vue&type=script&lang=js&"
import style0 from "./roleNumber.vue?vue&type=style&index=0&id=1ccf31ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccf31ce",
  null
  
)

export default component.exports